import { collection, onSnapshot } from "firebase/firestore";
import { dbFinancialPromotions as db } from "../../../../backend/firebaseConfig";

const FINANCIAL_PROMOTIONS_COLLECTION = "Financial Promotions Content";

const normaliseDateValue = (value) => {
  if (!value) return "";

  if (value?.toDate) {
    return value.toDate().toISOString();
  }

  if (typeof value === "object" && typeof value.seconds === "number") {
    return new Date(value.seconds * 1000).toISOString();
  }

  return value;
};

export const subscribeToFinancialPromotionResponses = ({
  onData,
  onError,
} = {}) => {
  const collectionRef = collection(db, FINANCIAL_PROMOTIONS_COLLECTION);

  return onSnapshot(
    collectionRef,
    (snapshot) => {
      const responses = snapshot.docs.map((doc) => {
        const data = doc.data();

        return {
          id: doc.id,
          ...data,

          responseId: data.responseId || doc.id,
          promotionId: data.promotionId || "",

          createdAt: normaliseDateValue(data.createdAt),
          updatedAt: normaliseDateValue(data.updatedAt),
          approvedAt: normaliseDateValue(data.approvedAt),
          exportedAt: normaliseDateValue(data.exportedAt),
        };
      });

      onData?.(responses);
    },
    (error) => {
      console.error("[Financial Promotions] Realtime listener failed:", error);

      onError?.(error);
    },
  );
};
